import React  from  'react'
import PropTypes from 'prop-types'


const Doughnut = props => (
    <div>
        <div className="doughnut">
            <div className="doughnut-inner" style={{transform: `rotate(${props.degrees}deg) `}}></div>
        </div>
    </div>
)

Doughnut.defaultProps = {
    degrees: '10'
}

Doughnut.prototype = {
    degrees: PropTypes.string.isRequired
}

export default Doughnut;